import { useEffect, useState } from "react";
import { STATIC_STRINGS } from "@asez/shared";
import { FILTER_KEYS, SIZES } from "@asez/shared";
import { FilterListItem } from "./FilterListItem";
import { initialFilters } from "./index";
import { getSkills } from "../../../services";
import { useParams } from "react-router-dom";
import Chip from "@mui/material/Chip";
import { GenericAutocomplete } from "@asez/component-library";

export const AreasFilter = ({ filters, updateFilters }) => {
  const { assessmentId } = useParams();
  const [strongAreasOptions, setStrongAreasOptions] = useState<string[]>([]);

  useEffect(() => {
    const getStrongAreas = async () => {
      try {
        const res = (await getSkills(assessmentId)) as string[];
        setStrongAreasOptions(res);
      } catch (error) {
        console.error("Error fetching skills:", error);
      }
    };
    getStrongAreas();
  }, [assessmentId]);
  return (
    <FilterListItem
      filterName={STATIC_STRINGS.STRONG_AREAS}
      resetHandler={() => {
        updateFilters(
          FILTER_KEYS.STRONG_AREAS,
          initialFilters[FILTER_KEYS.STRONG_AREAS]
        );
      }}
      Component={
        <div className="flex flex-col gap-1">
          <GenericAutocomplete
            size={SIZES.sm}
            onChangeHandler={(e, newValue) => {
              updateFilters(FILTER_KEYS.STRONG_AREAS, newValue);
            }}
            options={strongAreasOptions}
            value={filters[FILTER_KEYS.STRONG_AREAS] || []}
            renderTags={() => null}
          />
          <div className="flex gap-1 p-1 h-14 overflow-x-auto strong-areas-container">
            {filters[FILTER_KEYS.STRONG_AREAS]?.map((tag, index) => (
              <Chip
                key={index}
                label={tag}
                onDelete={() =>
                  updateFilters(
                    FILTER_KEYS.STRONG_AREAS,
                    filters[FILTER_KEYS.STRONG_AREAS]?.filter(
                      (_, i) => i !== index
                    )
                  )
                }
                sx={{
                  "& .MuiChip-deleteIcon": {
                    color: "var(--color-neutral-dark)",
                  },
                }}
              />
            ))}
            {filters[FILTER_KEYS.STRONG_AREAS]?.length === 0 && (
              <div className="w-full h-full flex justify-center items-center">
                {STATIC_STRINGS.NO_AREAS_SELECTED}
              </div>
            )}
          </div>
        </div>
      }
    />
  );
};
